document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.querySelector('.menu-toggle');
    const drawer = document.querySelector('.drawer');

    toggle.addEventListener('click', () => {
        toggle.classList.toggle('is-open');
        drawer.classList.toggle('is-open');
    });
});